<template>
  <div class="page-content">
    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/admin/devices/${item.id}/edit`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.serial_number }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  item.mac_address
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <v-row class="justify-content-end mr-15">
          <Apps
            :selectedRows.sync="selectedRows"
            @download_apps="download_apps"
          ></Apps>
        </v-row>
        <div class="row">
          <bx-box
            :title="totalDevices + ' ' + $t('lang.admin.list_of_devices')"
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="filteredHeaders"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalDevices"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">{{
                    props.row.serial_number
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">{{
                    props.row.mac_address
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/admin/areas/${props.row.locationArea1}/edit`"
                      class="bx-link bx-link-bold"
                      >{{
                        props.row.description_area_locationArea1
                      }}</router-link
                    >
                  </bx-table-column>

                  <bx-table-column centered>
                    <div
                      style="width: 100px"
                    >
                      <v-select
                        class="my-2"
                        outlined
                        dense
                        :disabled="props.row.reader_type != 1"
                        hide-details=""
                        :items="workingModes"
                        v-model="props.row.working_mode"
                        @change="onChangeWorkingMode($event, props.row.id)"
                      ></v-select>
                    </div>
                  </bx-table-column>
                  <bx-table-column
                    centered
                    class="pt-5"
                    :style="!showColumn ? 'display:none' : ''"
                  >
                    <div class="d-flex align-items-center">
                      <bx-order-status
                        :status="stateNumber(props.row.state)"
                      ></bx-order-status>
                      {{ stateName(props.row.state) }}
                    </div>
                  </bx-table-column>
                  <bx-table-column centered>
                    <div style="width: 100px">
                      <v-select
                        class="my-2"
                        outlined
                        dense
                        hide-details=""
                        :items="readerTypes"
                        v-model="props.row.reader_type"
                        @change="onChangeReaderType($event, props.row.id)"
                      ></v-select>
                    </div>
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/admin/devices/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >Edit</router-link
                    >
                  </bx-table-column>
                  <bx-table-column
                    centered
                    class="align-items-center d-flex justify-content-center"
                    :style="!showColumn ? 'display: none' : ''"
                  >
                    <div :style="!showColumn ? 'display: none' : ''">
                      <v-checkbox
                        class="shrink mr-0 pt-0 mt-3"
                        v-if="props.row.state"
                        color="#9ac31c"
                        hide-details
                        @change="onSelectRecord(props.row)"
                        :value="props.row.mac_address"
                        v-model="selectedRows"
                      ></v-checkbox>
                    </div>
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Apps from "@/components/Apps";

let workingModes = [
  {
    text: "Purchase Entry",
    value: 0
  },
  {
    text: "Movement Exit",
    value: 1
  },
    { value: 3, text: "Movement" },

  {
    text: "Handheld",
    value: 2
  },
  {
    text: "Sale",
    value: 4
  },
    {
    text: "POS",
    value: 5
  },
    {
    text: "Exit/Sale",
    value: 6
  },
    {
    text: "Cabinet",
    value: 7
  }
];

let readerTypes = [
  { value: 0, text: "Normal" },
  { value: 1, text: "All" }
];
export default {
  components: { Apps },
  name: "DevicesList",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      selectedRows: [],
      selectedRecords: [],
      totalDevices: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1,
      workingModes: workingModes,
      readerTypes: readerTypes,
      showColumn: null
    };
  },
  computed: {
    filteredHeaders() {
      if (this.columns) {
        return this.columns.filter(header => header.display === true);
      }
      return [];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async download_apps(app) {
      this.selectedRows.forEach(async value => {
        await this.$api.nms.update_apps(value, app);
      });
    },
    onSelectRecord(item) {
      let foundIndex = this.selectedRecords.findIndex(x => x.id === item.id);
      if (foundIndex === -1) {
        this.selectedRecords.push(item);
      } else {
        this.selectedRecords.splice(foundIndex, 1);
      }
    },
    stateName(state) {
      if (state === "ON") {
        return this.$t("lang.admin.online");
      } else if (state === "OFF") {
        return this.$t("lang.admin.offline");
      } else {
        return "";
      }
    },
    stateNumber(state) {
      if (state === "ON") {
        return 3;
      } else if (state === "OFF") {
        return 2;
      } else {
        return "";
      }
    },
    onChangeWorkingMode(value, id) {
      try {
        this.$api.device.update({
          id: id,
          working_mode: value
        });
      } catch (error) {
        console.error(error);
      }
    },
    onChangeReaderType(value, id) {
      try {
        this.$api.device.update({
          id: id,
          reader_type: value
        });
      } catch (error) {
        console.error(error);
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      let locationId = localStorage.getItem("location_id");
      try {
        let devices = await this.$api.device.list(locationId, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });
        try {
          let devicesList = await this.$api.nms.list();
          let macList = devicesList.map(x => x.mac);
          for (let i = 0; i < devices.results.length; i++) {
            if (macList.find(x => x === devices.results[i].mac_address)) {
              let foundArray = devicesList.find(
                x => x.mac === devices.results[i].mac_address
              );
              devices.results[i]["state"] = foundArray.state;
              devices.results[i]["hostname"] = foundArray.hostname;
            }
          }
        } catch (error) {
          console.error(error);
        }

        this.data = devices.results;
        this.totalDevices = devices.count;
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          this.columns = [
            {
              field: "serial_number",
              label: this.$t("lang.admin.label_serial_number"),
              centered: true,
              display: true
            },
            {
              field: "mac_address",
              label: this.$t("lang.admin.label_mac_address"),
              centered: true,
              display: true
            },
            {
              field: "locationArea1",
              label: this.$t("lang.admin.label_location_area_1"),
              centered: true,
              display: true
            },
            {
              field: "working_mode",
              label: this.$t("lang.admin.working_mode"),
              left: true,
              display: true
            },
            {
              field: "state",
              label: this.$t("lang.admin.label_state"),
              left: true,
              display: this.showColumn
            },
            {
              field: "reader_type",
              label: this.$t("lang.admin.label_reader_type"),
              left: true,
              display: true
            },
            {
              field: "",
              label: this.$t("lang.admin.label_action"),
              centered: true,
              display: true
            },
            {
              field: "action",
              label: this.$t("lang.inbound.dashboard.table_field_11"),
              centered: true,
              display: false
            },
            {
              field: "select",
              label: "",
              centered: true,
              display: true
            }
          ];
          this.shouldLoading = false;
          this.selectedRecords = [];
          this.selectedRows = [];
        }, 100);
      }
    }
  },
  watch: {
    data(data) {
      this.showColumn = data.some(row => row.state);
    }
  }
};
</script>
